import React from 'react';
import {RoutePermittedRole} from '../../shared/constants/AppEnums';

const ManageShops = React.lazy(() => import('.'));
const CreateShopInfo = React.lazy(() => import('./create-shop'));
const ShopDetailsInfo = React.lazy(() => import('./shop-details'));
const FeaturedShops = React.lazy(() => import('./featured-shops'));

export const manageShopConfig = [
  {
    path: '/manage-shops',
    element: <ManageShops />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/manage-shops/addShop',
    element: <CreateShopInfo />,
  },
  {
    path: '/manage-shops/featured-shops',
    element: <FeaturedShops />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/manage-shops/Details/:id',
    element: <ShopDetailsInfo />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/shop-details',
    element: <ShopDetailsInfo />,
  },
];
